import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';

import styles from './InputNumber.module.scss';

interface InputNumberProps {
  name: string;
  registerOptions?: any;
  label: string;
  placeholder?: string;
  disabled?: boolean;
  size?: 'large' | 'medium';
  inline?: boolean;
  type?: string;
  isCouponValid?: boolean;
  uppercase?: boolean;
  options?: {
    min?: number;
    max?: number;
    step?: number;
    maxlength?: number;
    required?: boolean;
  };
  isNumber?: boolean; // Ny prop för att avgöra om formatering ska tillämpas
}

export const InputNumber: React.FC<InputNumberProps> = ({
  name,
  registerOptions = {},
  label,
  placeholder = '',
  disabled,
  size = 'large',
  inline,
  type = 'text',
  isCouponValid,
  uppercase,
  options,
  isNumber = false, // Standardvärde är false
  ...rest
}) => {
  const {
    register,
    watch,
    setValue, // Här lägger vi till setValue från useFormContext
    formState: { errors },
  } = useFormContext();
  const value = watch(name);

  // Funktion för att formatera tal med mellanrum
  const formatNumber = (input: string) => {
    // eslint-disable-next-line no-param-reassign
    input = input.replace(/\s+/g, '').replace(/\D/g, '');
    return input.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  };

  useEffect(() => {
    if (isNumber && value) {
      setValue(name, formatNumber(value));
    }
  }, [value, isNumber, setValue, name]);

  return (
    <div
      className={`${styles.container} ${styles[size]} ${inline ? styles.inline : ''} ${
        uppercase ? styles.upperCase : ''
      }  `}
    >
      <input
        {...register(name, registerOptions)}
        type={type}
        id={name}
        name={name}
        spellCheck="false"
        placeholder={placeholder}
        autoComplete="off"
        disabled={disabled}
        className={`${value ? styles.value : ''} ${errors[name] ? styles.error : ''} ${
          isCouponValid ? styles.greenBorder : ''
        }`}
        {...options}
        {...rest}
      />
      <label htmlFor={name} className={value && styles.value}>
        {label}
      </label>
      <ErrorMessage
        name={name}
        errors={errors}
        render={({ message }) => <span className={styles.errorMessage}>{message}</span>}
      />
    </div>
  );
};
